import { combineEpics } from 'redux-observable';
import { searchUsersEpic } from './search-users';
import { updateUserEpic } from './update-user';
import { loadUserAfterLoginEpic } from './load-after-login';
import { getUserEpic } from './get-user';
import { updateUserAvatarEpic } from './update-user-avatar';
import { deleteUserEpic } from './delete-user';
import { updateUserAgreementEpic } from './update-user-agreement';
import { checkAdditionalEmails } from './check-additional-emails';
import { createAdditionalAccountEpic } from './create-additional-account';
import { redirectAfterSuccessEpic } from './redirect-after-success';
import { deleteAdditionalAccountEpic } from './delete-additional-account';

const userEpic = combineEpics(
  updateUserEpic,
  searchUsersEpic,
  loadUserAfterLoginEpic,
  getUserEpic,
  updateUserAvatarEpic,
  deleteUserEpic,
  updateUserAgreementEpic,
  checkAdditionalEmails,
  createAdditionalAccountEpic,
  redirectAfterSuccessEpic,
  deleteAdditionalAccountEpic
);

export default userEpic;
